import { ServiceResult } from '../models';
import { toByteArray } from 'base64-js';
import { saveAs } from 'file-saver';
import { LANGUAGES } from '../constants';
import { Language } from '../enums';

export const apiCall = async <T extends ServiceResult>(responsePromise: Promise<T>, onSuccess: (reponse: T) => Promise<void>, onError: (response?: T) => Promise<void>) => {
    let response: T = null as never;

    try {
        response = await responsePromise;
    } catch { }

    if (response && !response.hasError) {
        await onSuccess(response);
    } else {
        await onError(response);
    }

    return response;
};

export const apiCalls = async <T extends ServiceResult>(responsePromises: Promise<T[]>, onSuccess: (reponses: T[]) => Promise<void>, onError: () => Promise<void>) => {
    let responses: T[] = [];

    try {
        responses = await responsePromises;
    } catch { }

    if (responses && responses.every(x => x && !x.hasError)) {
        await onSuccess(responses);
    } else {
        await onError();
    }
};

export const saveDocument = (fileName: string, base64: string, mimeType = 'application/pdf') => {
    const bytes = toByteArray(base64);
    const blob = new Blob([bytes], { type: mimeType });

    saveAs(blob, fileName);
};

export const isNullOrUndefined = <T>(value: T) => value === null || value === undefined;

export const hasNullOrUndefined = <T>(object: T, ...specificKeys: Array<keyof T>) =>
    (specificKeys.length ? specificKeys : Object.keys(object as object) as Array<keyof T>).some(x => isNullOrUndefined(object[x]));

export const nonProduction = process.env.REACT_APP_IS_DEVELOPMENT === 'true';

export const getDefaultLanguage = (language: string) => {
    if (language == 'zh') {
        language = 'cn';
    }

    const foundValue = LANGUAGES.find(x => x.code == language);

    return foundValue && foundValue.key ? foundValue.key : Language.En;
};

export const getFormData = (object: object): FormData => Object.keys(object).reduce((formData, key) => {
    formData.append(key, (object as never)[key]);

    return formData;
}, new FormData());
